import {Component, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { PatientMessageData, RestApiService } from '../../../services/rest-api.service';
import { ToastService } from '../../custom/messaging/toast/toast.service';
import {PatientService} from "../../../services/patient.service";

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss']
})
export class MessageDialogComponent implements OnInit {
  patientMessage: PatientMessageData;
  agencyName: string;
  errorMessage?: string;

  constructor(public modal: NgbActiveModal, private rest: RestApiService,
              private toast: ToastService, private spinner: NgxSpinnerService,
              private patient: PatientService) {
  }

  ngOnInit(): void {
    this.patientMessage = {messageType: "account_update", messageBody: "", messageCreationDate: ""};
    this.agencyName = this.patient.currentAgency.name;
  }

  async sendRequest() {
    if (!this.patientMessage.messageBody
          || this.patientMessage.messageBody.trim().length === 0) {
          this.errorMessage = "Message is required";
          return;
        }
    try {
      await this.spinner.show();
      await this.rest.createPatientMessage(this.patientMessage);
      this.modal.close();
      await this.spinner.hide();
      this.toast.showSuccess("Message Sent!");
    } catch (err) {
      await this.spinner.hide();
      this.toast.showDanger("Error! Message Not Sent.");
      console.log(this.rest.errorMessage(err));
    }
  }
}
